<template>
  <v-app id="app">
    <component :is="layout">
      <router-view :key="$route.fullPath" />
    </component>
  </v-app>
</template>

<script>
import { Api } from "@/core/api.js";
const api = new Api();
const default_layout = "default";

export default {
  computed: {
    layout() {
      var layout =
        typeof this.$route.meta.layout !== "undefined"
          ? this.$route.meta.layout
          : default_layout;
      return layout + "-layout";
    },
    key() {
      return moment().valueOf();
    }
  }
};
</script>

<style lang="scss"></style>
